<template>
  <div class="u-box">
  	<div class="user-mask" v-if="show_user"></div>
  	<div class="user-mask-model" v-if="show_user" @click="show_user = false">
  		<div class="user-mask-model-rect" @click.stop v-if="data">
  			<div class="user-mask-model-rect-user">
  				<div class="user-mask-model-rect-user-left">
  					<img class="user-mask-model-rect-user-left-img" :src="data.headPortrait" alt="" />
  					<div class="user-mask-model-rect-user-content">
  						<span class="user-mask-model-rect-user-content-span">{{data.nickName}}</span>
  						<span class="user-mask-model-rect-user-content-span1">ID：{{data.recodeCode}}</span>
  					</div>
  				</div>
				<img class="user-mask-model-rect-user-img" src="../../assets/image/tanchuang_x_b@2x.png" alt="关闭" @click="show_user = false" />
  			</div>
			<div class="user-mask-model-rect-btn" v-if="isAdmin == 1">
				<div class="user-mask-model-rect-btn-item" @click="addAdmin">{{$t('all.tianjiaguanliyuan')}}</div>
				<div class="user-mask-model-rect-btn-xian"></div>
				<div class="user-mask-model-rect-btn-item" @click="bannedToPostUser" v-if="data && data.subjoinParameter && data.subjoinParameter.chatRoomUserCurrentRecordsInfo && data.subjoinParameter.chatRoomUserCurrentRecordsInfo.isBannedToPost==0">{{$t('all.jinyan')}}</div>
				<div class="user-mask-model-rect-btn-item" @click="relieveBannedToPostUser" v-if="data && data.subjoinParameter && data.subjoinParameter.chatRoomUserCurrentRecordsInfo && data.subjoinParameter.chatRoomUserCurrentRecordsInfo.isBannedToPost==1">{{$t('all.jiechujinyan')}}</div>
				<div class="user-mask-model-rect-btn-xian"></div>
				<div class="user-mask-model-rect-btn-item" @click="kickOutChatRoom">{{$t('all.tichufangjian')}}</div>
			</div>
			<div class="user-mask-model-rect-list" ref="listContainer" @scroll="handleScroll">
				<div class="user-mask-model-rect-list-title">{{$t('all.zhibojilu')}}</div>
				<zbjlItem v-for="(item,index) in list" :key="index" :data="item"/>
				<kong v-if="isKong"/>
			</div>
  		</div>
  	</div>
  </div>
</template>

<script>
import { getChatRoomUserDetails,addAdmin,getUserLiveRecordList,relieveBannedToPostUser,bannedToPostUser,kickOutChatRoom } from "@/api/zhibo";
import kong from "../kong/kong.vue";
import zbjlItem from "../zbjlItem/zbjlItem.vue";
export default {
  components: {
    kong,
	zbjlItem
  },
  data() {
    return {
	  show_user:false,
	  data:'',
	  form:{
		toUserId:'',
		liveId:this.$route.query.liveId
	  },
	  queryParams: {
	    page: 1,
	    size: 10,
		viewUserId:''
	  },
	  list: [],
	  isKong:false,
	  hasMore: true,
	  // 1. 新增一个加载状态锁，防止重复请求
	  isLoading: false,
	  isZb:false,
	  isAdmin:0
    };
  },
  mounted() {
	
  },
  methods: {
	showUser(userId){
		this.show_user = true
		this.form.toUserId = userId
		this.queryParams.viewUserId = userId
		this.getChatRoomUserDetails()
		this.getUserLiveRecordList()
	},
	//直播间用户详情
	async getChatRoomUserDetails(){
		this.data = ''
		const res = await getChatRoomUserDetails(this.form)
		this.data = res.data
		if(res.data.chatRoomDetails.hostUserInfo.userId == JSON.parse(this.$store.state.userId)){
			this.isZb = true
		}else{
			this.isZb = false
		}
		this.isAdmin = res.data.chatRoomUserCurrentRecordsInfo.isAdmin
	},
	//添加管理员
	async addAdmin(){
		const res = await addAdmin(this.form)
		this.$message({ message: this.$t('all.caozuochenggong'),type: 'success'});
		this.show_user = false
		this.$emit('addAdmin')
	},
	//禁言
	async bannedToPostUser(){
		const res = await bannedToPostUser(this.form)
		this.$message({ message: this.$t('all.caozuochenggong'),type: 'success'});
		this.getChatRoomUserDetails()
	},
	//解除禁言
	async relieveBannedToPostUser(){
		const res = await relieveBannedToPostUser(this.form)
		this.$message({ message: this.$t('all.caozuochenggong'),type: 'success'});
		this.getChatRoomUserDetails()
	},
	//踢出房间
	async kickOutChatRoom(){
		this.form.kickOutMinutes = 1
		const res = await kickOutChatRoom(this.form)
		this.$message({ message: this.$t('all.caozuochenggong'),type: 'success'});
		this.show_user = false
	},
	// 获取直播记录列表
	async getUserLiveRecordList() {
	  // 2. 如果正在加载或没有更多数据，则直接返回
	  if (this.isLoading || !this.hasMore) {
	    return;
	  }
	
	  try {
	    // 3. 发起请求前，将加载状态设为 true
	    this.isLoading = true;
	
	    const response = await getUserLiveRecordList(this.queryParams);
	    const newList = response.rows || [];
	
	    if (this.queryParams.page === 1) {
	      this.list = newList;
	    } else {
	      this.list = [...this.list, ...newList];
	    }
	
	    const totalPages = Math.ceil((response.total || 0) / this.queryParams.size);
	    this.hasMore = this.queryParams.page < totalPages;
	    if(response.total > 0){
			this.isKong = false
		}else{
			this.isKong = true
		}
	  } catch (error) {
	    console.error("获取直播记录列表失败:", error);
	  } finally {
	    // 4. 请求结束（无论成功或失败），将加载状态恢复为 false
	    this.isLoading = false;
	  }
	},
	
	// 滚动事件处理函数
	handleScroll() {
	  // 同样增加 isLoading 判断，防止在请求期间触发
	  if (this.isLoading || !this.hasMore) {
	    return;
	  }
	
	  const container = this.$refs.listContainer;
	  // 判断滚动条是否到达底部（或接近底部）
	  const isAtBottom = container.scrollTop + container.clientHeight >= container.scrollHeight - 10;
	
	  if (isAtBottom) {
	    console.log("滚动到底部，准备加载第", this.queryParams.page + 1, "页");
	    this.queryParams.page++;
	    this.getUserLiveRecordList();
	  }
	},
	
	
  }
};
</script>
<style scoped lang="scss">
	@import "./user.css";
</style>


// WEBPACK FOOTER //
// user.vue?55a85201